import { render, staticRenderFns } from "./centerCmp.vue?vue&type=template&id=fa75e126&"
import script from "./centerCmp.vue?vue&type=script&lang=js&"
export * from "./centerCmp.vue?vue&type=script&lang=js&"
import style0 from "./centerCmp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports